<template>
  <div class="col-12">
    <h2>ProxyScrape Premium - Frequently Asked Questions</h2>
  </div>
  <div class="col-md-6">
    <div id="accordion" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne1"
            aria-expanded="true">
            What is a premium proxy?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne1"
          class="collapse"
          data-parent="#accordion">
          <div
            class="card-body">
            Premium proxies are shared datacenter proxies located all across the globe.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne2"
            aria-expanded="true">
            Do the
            premium proxies support
            username:password authentication?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne2"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">No, our premium proxies do not support username:password
            authentication. This is because we bill depending on the amount
            of authenticated devices.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne3"
            aria-expanded="true">
            When does the proxy list refresh?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne3"
          class="collapse"
          data-parent="#accordion"
          style="">
          <div
            class="card-body">
            The premium proxy list does not refresh. If your proxies get banned too quickly,
            it is recommended to buy a bigger package. For very sensitive websites,
            we recommend using
            <a
              style="text-decoration: underline;"
              href="https://proxyscrape.com/residential-proxies">
              rotating residential proxies
            </a> instead.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne4"
            aria-expanded="true">
            Are the premium proxies rotating?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne4"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            No, our premium proxies are static datacenter proxies. If you are looking for
            rotating proxies, please take a look at our
            <a
              href="https://proxyscrape.com/residential-proxies"
              style="text-decoration: underline;">residential proxies
            </a>.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne5"
            aria-expanded="true">
            What will happens if proxies get banned on my target website?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne5"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            If a proxy gets banned on your target website, you will be unable to use it for
            that website for the duration of the ban. We recommend you buy enough proxies
            to keep your activities running smoothly and account for bans.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne6"
            aria-expanded="true">
            Do you replace dead proxies?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne6"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            Our premium subscriptions do not contain any dead proxies. If some proxies are
            marked as offline, you can be sure our 24/7 monitoring team is working on getting
            them back online as soon as possible. If you are experiencing issues with the proxies
            for a long duration, please feel free to contact our support team
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne7"
            aria-expanded="true">
            How fast are the premium proxies?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne7"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            The average response time for our proxies is:
            <ul>
              <li>HTTP(s): 375ms</li>
              <li>Socks4 & Socks5: 575ms</li>
            </ul>
            Our total network capacity is 20Gbps.
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="col-md-6">
    <div id="accordion2" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne8"
            aria-expanded="true">
            Are premium proxies the best proxy type one can buy?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne8"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            Premium proxies are the best proxies if you need a lot of fast, stable proxies to
            scrape websites that don't quickly ban.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne9"
            aria-expanded="true">
            Can I change my proxy list?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne9"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            You can only change your proxy list by upgrading your account. If your proxies are
            not working correctly from the start, we recommend you contact our support as soon
            as possible so we can troubleshoot the issue. We might suggest replacing your package
            with another proxy type free of charge. If your proxies are banned because you actively
            used them, we do not provide any proxy changes and recommend upgrading your account
            to a bigger package to prevent bans.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne10"
            aria-expanded="true">
            Are the premium proxies IPv4 or IPv6?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne10"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            All the proxies on our website are IPv4. At the moment, we do not have any plans to
            support IPv6.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne11"
            aria-expanded="true">
            Do you have City Specific proxies?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne11"
          class="collapse"
          data-parent="#accordion2" >
          <div class="card-body">
            No, at the moment, we do not have city-specific proxies.
            If you are looking for city-specific proxies, please let our support know
            so we can add it to our future roadmap.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne12"
            aria-expanded="true">
            Does the premium plan auto-renew?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne12"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            No, we do not renew subscriptions automatically. You will have to do it manually
            via the dashboard. However, it is on our roadmap to make auto-renewals possible.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne13"
            aria-expanded="true">
            Do you provide software where we can use the proxies?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne13"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            No, we do not provide software to use the proxies on, and users should have their
            software ready to use before buying the proxies. If you are looking for a proxy
            checker to test our proxies with on your device, we recommend
            <a
              href="https://openproxy.space/software/proxy-checker"
              style="text-decoration: underline;" target="_blank">
              Unfx Proxy checker
            </a>.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne14"
            aria-expanded="true">
            Does ProxyScrape premium have an API?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne14"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            Yes, we provide an API to download your proxy list & authenticate your IPs.
            Take a look at our
            <a
              href="https://docs.proxyscrape.com/#b91b6c21-172c-48b3-ab99-6f297d5d9a7b"
              style="text-decoration: underline;" target="_blank">API documentation
            </a>.
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
